const spinner = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <style>
@keyframes a0_t { 0% { transform: translate(10px,10px) rotate(0deg); } 100% { transform: translate(10px,10px) rotate(720deg); } }
@keyframes a0_do { 0% { stroke-dashoffset: 49.8px; animation-timing-function: cubic-bezier(.4,0,.6,1); } 37.5% { stroke-dashoffset: 0px; animation-timing-function: cubic-bezier(.8,0,.2,1); } 75% { stroke-dashoffset: -49.8px; } 100% { stroke-dashoffset: -49.8px; } }
    </style>
    <ellipse rx="8" ry="8" fill="none" stroke="currentColor" stroke-width="2" stroke-dashoffset="49.8" stroke-dasharray="49.9" transform="translate(10,10)" style="animation: 2s linear infinite both a0_t, 2s linear infinite both a0_do;"/>
</svg>`;

export default spinner;
